import { Link } from "react-router-dom";
import { ArrowRight, Wand2 } from "lucide-react";
import { hero } from "../mock/mock";
import { Button } from "./ui/button";

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={hero.image}
          alt="Elegant living room with custom drapery"
          className="w-full h-full object-cover kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/20" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 w-full pt-24">
        <div className="max-w-2xl">
          <p className="reveal in-view text-[#E7CFA6] tracking-[0.25em] uppercase text-xs md:text-sm mb-6">
            {hero.eyebrow}
          </p>
          <h1 className="font-serif text-white text-4xl md:text-6xl lg:text-7xl leading-[1.05] mb-6">
            {hero.title}
          </h1>
          <p className="text-white/85 text-lg md:text-xl leading-relaxed mb-9 max-w-xl">
            {hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollTo("contact")}
              className="bg-[#A17E4A] hover:bg-[#8a6a3c] text-white rounded-full px-8 py-6 text-base group"
            >
              Schedule Free Consultation
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Link to="/visualizer">
              <Button
                variant="outline"
                className="w-full sm:w-auto bg-white/10 backdrop-blur border-white/50 text-white hover:bg-white hover:text-[#2A2521] rounded-full px-8 py-6 text-base"
              >
                <Wand2 className="w-4 h-4 mr-2" />
                Try the Drape Visualizer
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/70">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-10 bg-white/40 relative overflow-hidden">
          <span className="absolute top-0 left-0 w-full h-1/2 bg-white animate-[slideDown_1.8s_ease-in-out_infinite]" />
        </div>
      </div>

      <style>{`@keyframes slideDown{0%{transform:translateY(-100%)}100%{transform:translateY(200%)}}`}</style>
    </section>
  );
}
